<template>
   <!--产地价格-->
   <div id='originPrice' class='origin_price_container'></div>
</template>
<script>
import { http } from '@/http'
import echarts from 'echarts'
import 'echarts/chart/pie'
// import { option as pricelineOption } from '@/zjljChartsConfig/originPriceOption.js' // 配置项
// import {option as dataResponse} from '@/zjljChartsConfig/provideData.js' //临时数据
import { filterArr } from '@/utils/dataFilter.js' // 数组空值转换

export default{
  props: {
    secondProductId: {
      type: Number,
      default: 0
    },
    countyId: {
      type: Number,
      default: 0
    },
    legendPosition: {
      type: String,
      default: '73%'
    },
    legendFontSize: {
      type: Number,
      default: 18
    },
    fontSize: {
      type: Number,
      default: 20
    },
    fontWeight: {
      type: String,
      default: 'normal'
    },
    showCount: { // 显示的数据数量
      type: Number,
      default: 12
    }
  },
  data () {
    return {
      xAxisData: [],
      dataLastYearStore: [],
      dataCurrentYearStore: [],
      showIndexPre: 0,
      showIndexLast: 15,
      chartOption: {
        title: {
          text: '',
          x: '10',
          bottom: '5%',
          textStyle: {
            color: '#fff',
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['去年价格', '今年价格'],
          textStyle: {
            fontSize: this.legendFontSize,
            color: '#fff'
          },
          x: '76%'
        },
        xAxis: [{
          splitLine: {
            show: false,
            color: '#141e34'
          }, // 隐藏内部线
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#7591d8',
              width: 0 // 这里是为了突出显示加上的
            }
          },
          axisLabel: {
            interval: 0,
            rotate: 0,
            textStyle: { // 刻度值的字体样式设置
              color: '#7591d8',
              fontSize: this.fontSize,
              fontWeight: this.fontWeight

            },
            margin: 20
          },
          boundaryGap: false,
          data: []
        }],
        yAxis: [{
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#7591d8',
              width: 1 // 这里是为了突出显示加上的
            }
          },
          axisLabel: {
            textStyle: { // 刻度值的字体样式设置
              color: '#7591d8',
              fontSize: this.fontSize,
              fontWeight: this.fontWeight
            },
            margin: 30
            // 刻度值离轴线多远的距离
          }
        }],
        series: [{
          name: '0.8斤菠萝',
          type: 'line',
          data: [],
          smooth: true,
          itemStyle: {
            normal: {
              color: 'red', // 折线点的颜色
              lineStyle: {
                color: 'red' // 折线的颜色
              }
            }
          }
        }
        ]
      }
    }
  },
  methods: {
    // 获取地图数据
    getData (cb) {
      switch (this.$route.name) {
        case 'gdLitchi': {
          this.productId = this.secondProductId || this.productId || this.$route.params.product_id || 8048
          break
        }
        case 'sxhlg': {
          this.productId = this.secondProductId || this.productId || this.$route.params.product_id || 7832
          break
        }
        case 'mmlz': {
          this.productId = this.secondProductId || this.productId || this.$route.params.product_id || 8048
          break
        }
        case 'zjlj': {
          this.productId = this.secondProductId || this.productId || this.$route.params.product_id || 8016
          break
        }
        case 'mzyz': {
          this.productId = this.secondProductId || this.productId || this.$route.params.product_id || 8519
          break
        }
        default: {
          this.productId = this.secondProductId || this.productId || this.$route.params.product_id
        }
      }
      http.get('/canmou/tianji/product/origin_price?product_id=' + this.productId + '&county_id=' + this.countyId).then(res => {
        this.dataResponse = res.data
        // 线数据
        //  "min_price":[],
        //  "max_price":[], 当日最高价
        //  "avg_price":[],当日平均价格
        this.dataLastYearStore = filterArr(this.dataResponse.data.last_year_price)
        this.dataCurrentYearStore = filterArr(this.dataResponse.data.current_year_price)
        if (this.dataResponse.data.two_year_ago_price) {
          this.twoYearAgoPriceStore = filterArr(this.dataResponse.data.two_year_ago_price)
        }
        // x轴数据
        this.xAxisDataStore = this.dataResponse.data.date.map(item => {
          return `${item.substring(0, 2)} / ${item.substring(2, 4)}`
        })
        // 数据总数
        this.countAll = this.dataResponse.data.date.length
        if (this.dataResponse.status === 0) {
          cb && cb()
        }
      })
    },
    // 初始化数据
    initOption (data) {
      // 显示全部时 设置显示的间隔
      let gap = Math.floor(this.dataLastYearStore.length / this.showCount) - 1
      this.chartOption.xAxis[0].axisLabel.interval = gap > 0 ? gap : 0
      // console.log(this.dataLastYearStore)
      this.dataLastYear = this.dataLastYearStore.slice(0, this.dataLastYearStore.length)
      this.dataCurrentYear = this.dataCurrentYearStore.slice(0, this.dataLastYearStore.length)
      if (this.twoYearAgoPriceStore) {
        this.dataTwoYear = this.twoYearAgoPriceStore.slice(0, this.dataLastYearStore.length)
      }
      this.xAxisData = this.xAxisDataStore.slice(0, this.showCount)
      // x轴数据
      this.chartOption.xAxis[0].data = this.xAxisData
      // 线数据
      this.chartOption.series = [{
        name: '去年价格',
        type: 'line',
        data: this.dataLastYear,
        smooth: true
      },
      {
        name: '今年价格',
        type: 'line',
        data: this.dataCurrentYear,
        smooth: true
      }
      ]
      if (this.$route.name === 'xvData') {
        this.chartOption.legend.data = ['去年价格', '今年价格', '前年价格']
        this.chartOption.series.push(
          {
            name: '前年价格',
            type: 'line',
            data: this.dataTwoYear,
            smooth: true
          }
        )
      }
      // this.lineChart.setOption(this.chartOption)
    },
    changeLinePoint () {
      if (this.showIndexLast >= this.countAll) {
        this.showIndexPre = -1
        this.showIndexLast = this.showCount - 1
      }
      // 显示全部的写法
      this.showIndexPre = 0
      this.showIndexLast = this.dataLastYearStore.length
      // this.showIndexPre+=5;
      // this.showIndexLast+=5;
      this.dataLastYear.length = 0
      this.dataLastYear.push(...this.dataLastYearStore.slice(this.showIndexPre, this.showIndexLast))
      this.dataCurrentYear.length = 0
      this.dataCurrentYear.push(...this.dataCurrentYearStore.slice(this.showIndexPre, this.showIndexLast))
      this.xAxisData.length = 0
      this.xAxisData.push(...this.xAxisDataStore.slice(this.showIndexPre, this.showIndexLast))
      this.lineChart.setOption(this.chartOption)
    },
    initPage () {
      clearInterval(this.timer)
      if (!this.lineChart) {
        this.lineChart = echarts.init(document.getElementById('originPrice'))
      } else {
        this.lineChart.clear()
      }
      this.lineChart.hideLoading()
      // 改变数据设置动效
      var that = this
      // 初始化
      function init () {
        // 获取数据
        that.getData(() => {
          // 处理返回数据
          that.initOption(that.dataResponse)
          // // 设置数据切换
          that.changeLinePoint()
        })
      }
      init()
      // 每天更新一次数据
      this.timer = setInterval(() => {
        init()
      }, 24 * 60 * 60 * 1000)
    }
  },
  watch: {
    secondProductId () {
      this.initPage()
    },
    $route (to, from) {
      if (to.params && to.params.product_id !== from.params.product_id) {
        this.productId = to.params.product_id
        this.initPage()
      }
    }
  },
  mounted () {
    this.chartOption.legend.x = this.legendPosition
    this.initPage()
  }
}

</script>
<style lang='less' scoped>

  .origin_price_container{
    width: 100%;
    height:100%;
    background:none;
    padding:10px;
  }
</style>
